import { Flex, Button } from "@chakra-ui/react";
import DateRangePicker from "components/Input/DateRangePicker";
import { useDashboardPrincipal } from "core/features/dashboards/store";
import { FiRefreshCw } from "react-icons/fi";
import { useWindowSize } from "infra/helpers/window";

function DashboardHeader() {
  const { query, update, reload } = useDashboardPrincipal();

  const windowSize = useWindowSize();

  const isMobile = windowSize.width <= 768;

  return (
    <Flex flexDir={!isMobile ? "row" : "column"} mb="12px" flex={1}>
    
      <Flex gap="8px" pt="2px">
        <Button
          bg="white"
          w={"150px"}
          fontSize="14px"
          variant="outline"
          fontWeight="normal"
          onClick={() => reload()}
          leftIcon={<FiRefreshCw fontSize="16px" />}
        >
          atualizar
        </Button>
        <DateRangePicker
          onChange={(dataInicio, dataFim) => {
            update("dataInicio", dataInicio);
            update("dataFim", dataFim);
          }}
          value={{
            dataInicio: query.dataInicio,
            dataFim: query.dataFim,
          }}
        />
      </Flex>
    </Flex>
  );
}

export default DashboardHeader;
